// extracted by mini-css-extract-plugin
module.exports = {"star":"_1Wv_pS","icon":"_1WU-gf","active":"drTVET","black":"_22lFBk","red":"_13V8ck"};